import Service from '../AuthService';

const CreditType = {
  getAllCreditTypes() {
    return Service.get(`credit-types`);
  }
};

export default CreditType;
